export default "__VITE_ASSET__aac1c106__"